import { Injectable } from '@angular/core';
import { AaUnleashWrapperService } from '@theaa/aa-unleash-wrapper';
import { EnvironmentService } from 'src/app/environment.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  constructor(private readonly unleashService: AaUnleashWrapperService, private readonly envService: EnvironmentService) {}

  startUnleash(): void {
    this.unleashService.start({
      url: this.envService.routeModel.unleash?.url ?? '',
      appName: this.envService.routeModel.unleash?.appName ?? 'route-planner',
      environment: this.envService.routeModel.unleash?.environment,
      clientKey: this.envService.routeModel.unleashToken, // for local development, use the token from the git-ignored file
      refreshInterval: 30 // 30 seconds
    });
  }

  stopUnleash(): void {
    this.unleashService.stop();
  }

  onUpdate(callback: () => void): void {
    this.unleashService.onUpdate(() => {
      callback();
    });
  }

  isFeatureEnabled(featureName: string): boolean {
    return this.unleashService.isEnabled(featureName);
  }

  getVariantPayloadValue(featureName: string) {
    const variant = this.unleashService.getVariant(featureName);
    if (variant?.payload?.type === 'number') return Number(variant.payload.value);
  }
}
